/**
 * Best-effort extract of ASP.NET-style { errors: { General | general: "..." } }
 * or Error.message from axios failures.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
    if (!err || typeof err !== 'object') return fallback;

    const ax = err as {
        response?: { data?: { errors?: Record<string, unknown>; title?: string; message?: string } };
        message?: string;
    };
    const errors = ax.response?.data?.errors;
    if (errors && typeof errors === 'object') {
        const general = errors.General ?? errors.general;
        if (typeof general === 'string' && general.trim()) return general.trim();
        // First string value in errors object
        for (const v of Object.values(errors)) {
            if (typeof v === 'string' && v.trim()) return v.trim();
            if (Array.isArray(v) && typeof v[0] === 'string' && v[0].trim()) return v[0].trim();
        }
    }
    if (typeof ax.response?.data?.message === 'string' && ax.response.data.message.trim()) {
        return ax.response.data.message.trim();
    }
    if (typeof ax.message === 'string' && ax.message.trim() && !ax.message.startsWith('Request failed')) {
        return ax.message.trim();
    }
    return fallback;
}
